import React from "react";
import MaterialTable from "material-table";
import { Box, IconButton } from "@material-ui/core";
import LinearProgressBar from "components/linear_progress_bar";
import tableIcons, { options } from "components/universal/table_attributes";
import RescheduleIcon from "@material-ui/icons/History";
import EstimationHistory from "./EstimationHistory";




const EstimationTable = ({
    classes,
    data = [],
    loading = false,
    emptyMessage = "No data found",
    setAction, setCurrentSelection, currentSelection, action
}) => {


    const tableOptions1 = {
        ...options,
        paging: false,
        search: false,
        paging: false,

    };



    const columns = [
        {
            title: "Type",
            field: "type",

            headerStyle: {
                textAlign: "left",
                paddingLeft: "22px",
            },
            cellStyle: {
                textAlign: "left",
                paddingLeft: "22px",
            },

        },
        {
            title: "Position",
            field: "position",

        },
        {
            title: "Date",
            field: "date",
        },
        {
            title: "History",
            field: "",
            width: "20%",

            headerStyle: {
                textAlign: "left",

            },
            cellStyle: {
                width: "20%",
            }, render: (rowData) => {
                if (rowData?.type === "Approved") {
                    return ""
                }
                else if (rowData?.type === "Revised") {
                    return (
                        <IconButton onClick={() => {
                            setAction("est_history")
                            setCurrentSelection(rowData)
                        }}>
                            <RescheduleIcon />
                        </IconButton>

                    )
                }

            }
        },
        {
            title: "Inducted / Start",
            field: "inducted_start",


        }, {
            title: "TAT",
            field: "tat_days",


        }, {
            title: "ETD",
            field: "etd",

        }, {
            title: "Progress",
            field: "progress",
            render: (rowData) =>
                <div style={{ position: 'absolute', marginTop: '-10px', marginLeft: '25px' }}>
                    <LinearProgressBar
                        variant='determinate'
                        value={Number(rowData.progress)}
                        width='70px'
                        barHeight='20px'
                        bgColor={(rowData.progress > 0 && rowData.progress < 75) ? '#4FC605' : (rowData.progress >= 75 && rowData.progress < 100) ? '#FFB300' : rowData.progress >= 100 ? '#FF0202' : '#fff'}
                        color={rowData.progress >= 100 ? "#FFFFFF" : "#4D4F5C"}
                    />
                </div>

        },

    ]


    return (
        <Box className={classes?.spacing}>
            <MaterialTable
                style={{ boxShadow: "0px 1px 4px #00000033" }}
                isLoading={loading}
                icons={tableIcons}
                title=""
                columns={columns}
                data={data}
                options={tableOptions1}
                components={{ Toolbar: () => null }}
                localization={{
                    toolbar: {},
                    body: {
                        emptyDataSourceMessage: emptyMessage,
                        filterRow: { filterTooltip: "Filter" },
                    },
                }}
            />
            {action === "est_history" && (
                <EstimationHistory
                    currentSelection={currentSelection}
                    handleClose={() => setAction(null)}

                />
            )}
        </Box>
    );
};

export default EstimationTable;
